import { render, staticRenderFns } from "./tablekey.vue?vue&type=template&id=65970e64&"
import script from "./tablekey.vue?vue&type=script&lang=js&"
export * from "./tablekey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports